$(function ($) {
  gsap.registerPlugin(ScrollTrigger,SplitText,CustomEase)
  // const lenis = new Lenis({duration: 1.5});
  
  // lenis.on('scroll', ScrollTrigger.update);
  
  // gsap.ticker.add((time) => {
  //   lenis.raf(time * 1000); 
  // });
  // gsap.ticker.lagSmoothing(0);

  function createScrollTrigger(triggerElement, timeline) {
    ScrollTrigger.create({
      trigger: triggerElement,
      start: "top bottom",
      onLeaveBack: () => {
        timeline.progress(0);
        timeline.pause();
      },
    });
    ScrollTrigger.create({
      trigger: triggerElement,
      start: "top bottom",
      onEnter: () => {
        timeline.play();
        //ScrollTrigger.refresh();
      },
    });
  }
  
   document.querySelectorAll("[data-split-lines]").forEach(ele => {
     SplitText.create(ele, {
      type: "lines", // only split into words and lines (not characters)
      linesClass: "line", 
    });
   })
  document.querySelectorAll("[lines-slide-up]").forEach(function (element, index) {
    let tl = gsap.timeline({ paused: true });
    tl.fromTo(
      element.querySelectorAll(".line"), { opacity: 0, yPercent: 50, rotate: 3 },
      {
        opacity: 1,
        rotate: 0,
        yPercent: 0,
        duration: 0.5,
        ease: "back.out(3)",
        stagger: { amount: 0.25 },
      }
    );
    createScrollTrigger(element, tl);
  });
  /*copied codes*/
  const loadWrap = document.querySelector(".loader");
  if(loadWrap){
  const pageOverlay = document.querySelector(".page-overlay");
  const loadBg = loadWrap?.querySelector(".load-bg");
  gsap.set(loadBg, { transformOrigin: "50% 0%" });
  gsap.fromTo(
    pageOverlay, { opacity: 1 }, { opacity: 0, duration: 1.2, ease: "expo.inOut" }
  );
  gsap.fromTo(
    loadBg, { scaleY: 1, borderRadius: "0px 0px 0vw 0vw" },
    {
      scaleY: 0,
      borderRadius: "0px 0px 100vw 100vw",
      duration: 1.2,
      ease: "expo.inOut",
      onComplete: () => {
        gsap.set(loadWrap, { display: "none" });
      },
    }
  );
}
  const lottieAnimations = [
    "//ovabalance.eu/cdn/shop/t/67/assets/lottie_1.json?v=22352",
    "//ovabalance.eu/cdn/shop/t/67/assets/lottie_2.json?v=22352",
    "//ovabalance.eu/cdn/shop/t/67/assets/lottie_3.json?v=22352",
  ];
  function prefersReducedMotion() {
    const query = window.matchMedia("(prefers-reduced-motion: reduce)");
    return query.matches;
  }
  function setPositionAndTransform(container, position) {
    switch (position) {
    case "top-left":
      container.style.left = "0px";
      container.style.top = "0px";
      container.style.transform = "translate(-50%, -50%)";
      break;
    case "top-right":
      container.style.right = "0px";
      container.style.top = "0px";
      container.style.transform = "translate(50%, -50%)";
      break;
    case "bottom-left":
      container.style.left = "0px";
      container.style.bottom = "0px";
      container.style.transform = "translate(-50%, 50%)";
      break;
    case "bottom-right":
      container.style.right = "0px";
      container.style.bottom = "0px";
      container.style.transform = "translate(50%, 50%)";
      break;
    }
  }
  // document.querySelectorAll(".btn-wrap .btn").forEach((button) => {
  //   if (prefersReducedMotion()) return;
  //   button.addEventListener("mouseenter", );
  // });
  
  $("body").on("mouseenter", ".btn-wrap .btn", function () {
      if (prefersReducedMotion()) return;
      animateButtonHover(this);
  })
  function animateButtonHover(button) {
      if(button.hasAttribute("disabled"))return;
      const parentDiv = button.parentElement;
      const buttonSize = button.getBoundingClientRect();
      const numberOfAnimations = Math.floor(Math.random() * 2) + 1;

      for (let i = 0; i < numberOfAnimations; i++) {
        const lottieContainer = document.createElement("div");
        lottieContainer.style.position = "absolute";
        lottieContainer.style.width = "120px";
        lottieContainer.style.height = "120px";
        lottieContainer.style.pointerEvents = "none";

        const randomIndex = Math.floor(Math.random() * lottieAnimations.length);
        const selectedAnimation = lottieAnimations[randomIndex];

        const positions = [
          "top-left",
          "top-right",
          "bottom-left",
          "bottom-right",
        ];
        const selectedPosition =
          positions[Math.floor(Math.random() * positions.length)];

        setPositionAndTransform(lottieContainer, selectedPosition);
        parentDiv.appendChild(lottieContainer);

        const animation = lottie.loadAnimation({
          container: lottieContainer,
          renderer: "svg",
          loop: false,
          autoplay: true,
          path: selectedAnimation,
        });

        let tl = gsap.timeline({});

        tl.to(button, {
          scale: 0.95,
          duration: 0.25,
        }).to(button, {
          scale: 1,
          duration: 0.45,
          ease: "back.out(5)",
        });

        animation.addEventListener("complete", () => {
          lottieContainer.remove();
        });
      }
    }
  
  $('.review-wrap').each(function () {
    const $div = $(this);
    const productId = $div.data('sku');
    if(productId){
      loadProductRatingDetails(productId, $div);
    }
  });
  $("body").on({
    mouseenter: function () {
    $(this).find(".pb-alt--video")[0]?.play();
     // $(this).find(".pb-alt--video").play();
  },
    mouseleave: function () {
      const video = $(this).find(".pb-alt--video")[0];
      if (video) {
          video.pause();
          video.currentTime = 0;
      }
    }}, ".product-block-alt");
})